import { inject, Injectable, signal } from '@angular/core';
import {
  ApiService,
  EProductCategory,
  ETireDecInc,
  IAllData,
  IPaging,
  IProductSearchOptions,
  ITireDecIncRequire,
} from '@web-nx-ng-tsc/web-shared-data-access';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ILocalStorageModel, StorageService } from '@web-nx-ng-tsc/data-access';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

export const VISIBILITY = environment.visibility;

@Injectable({
  providedIn: 'root',
})
export class ProductService {
  private readonly apiService = inject(ApiService);
  private readonly storageService = inject(StorageService);
  private readonly loggingService = inject(LoggingService);

  private allProductSignal = signal<any>(undefined);
  private productDetailSignal = signal<any>(undefined);
  private productTiresSizeSignal = signal<any>(undefined);
  private productCompareList = signal<any>([]);
  private isTire = signal<boolean>(false);

  // for check new search or onClickLoadMore
  private optionsProductSignal = signal<any>(undefined);
  private productDetailLoadingSignal = signal<boolean>(false);

  // SECTION: GET SIGNAL //
  // NOTE: get allProductSignal
  getAllProductSignal() {
    return this.allProductSignal;
  }

  // NOTE: get allProductSignal
  getProductDetailSignal() {
    return this.productDetailSignal;
  }
  getProductTiresSizeSignal() {
    return this.productTiresSizeSignal;
  }

  getProductCompareList() {
    return this.productCompareList;
  }

  getProductDetailLoadingSignal() {
    return this.productDetailLoadingSignal;
  }

  getIsTire() {
    return this.isTire;
  }

  setIsTire(value: boolean) {
    this.isTire.set(value);
  }

  convertTypeCategory(type: string) {
    switch (type) {
      case 'Tire':
        return EProductCategory.TIRE;
      case 'Brake':
        return EProductCategory.BRAKE;
      case 'Lubricants':
        return EProductCategory.LUBRICANT;
      default:
        return EProductCategory.TIRE;
    }
  }

  // !SECTION
  // SECTION: CLEAR SIGNAL //
  // NOTE: clear allProductSignal
  clearAllProductSignal() {
    return this.allProductSignal.set(undefined);
  }

  // NOTE: clear allProductSignal
  clearProductDetailSignal() {
    return this.productDetailSignal.set(undefined);
  }

  clearProductCompareList() {
    this.productCompareList.set([]);
  }
  // !SECTION

  // SECTION: COMPARE PRODUCT FUNCTIONS //
  // NOTE: Add product to compare list
  addProductToCompare(productData: any) {
    const currentCompareList = this.productCompareList();
    const checkProductInList = currentCompareList.some((product: any) => product.id === productData.id);
    if (!checkProductInList) {
      currentCompareList.push(productData);
      this.productCompareList.set(currentCompareList);
    }
    this.loggingService.error('productCompareList [Service]', this.productCompareList());
  }

  deleteProductCompare(productId: string) {
    const newProductListCompare = this.productCompareList().filter((res: any) => res.id !== productId);
    this.productCompareList.set(newProductListCompare);
  }

  //!SECTION

  // SECTION: GET API //

  // SECTION: GET API //

  // NOTE: getAllProductByCategory //
  //#region
  /**
   * Fetches all products by category with optional filters.
   *
   * @param category - The product category (EProductCategory).
   * @param options - Optional filters for the product search.
   * @returns Observable of the product search result.
   */
  getAllProductByCategory(
    loadMore: boolean,
    category: string,
    options: IProductSearchOptions = {},
    paging?: IPaging
  ): Observable<any> {
    this.loggingService.log('FUNC | getAllProductByCategory[ProductService] category :', category);
    this.loggingService.log('FUNC | getAllProductByCategory[ProductService] options :', options);
    this.loggingService.log('FUNC | getAllProductByCategory[ProductService] paging :', paging);
    return this.apiService.getAllProductCategory(VISIBILITY, category, options, paging).pipe(
      tap((res: IAllData) => this.loggingService.log('TAP | getAllProductByCategory[ProductService] :', res)),
      tap((res: IAllData) => {
        this.loggingService.log('getAllProductByCategory options :', options);
        // Checks if the object has no keys
        if (loadMore) {
          this.loggingService.log('if aaa', options);

          this.allProductSignal.update((data: any) => {
            this.loggingService.log('data in update :', data);
            let val: any;
            if (data) {
              val = data.rows.slice();
              this.loggingService.log('val in update :', val);
              val.push(...res.rows);
            } else {
              val = res.rows;
            }
            return { ...res, rows: val };
          });
        } else {
          this.loggingService.log('else aaa', options);
          this.allProductSignal.set(res);

          this.optionsProductSignal.set(options);
        }

        // if (Object.keys(options).length !== 0) {
        //   this.loggingService.log('if');
        //   this.allProductSignal.set(res);
        // } else {
        //   this.loggingService.log('else');
        //   this.allProductSignal.update((data: any) => {
        //     this.loggingService.log('data in update :', data);
        //     let val: any;
        //     if (data) {
        //       val = data.rows.slice();
        //       this.loggingService.log('val in update :', val);
        //       val.push(...res.rows);
        //     } else {
        //       val = res.rows;
        //     }
        //     return { ...res, rows: val };
        //   });
        // }
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getAllProductByCategory[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  //#endregion

  getProductTable(category: string, options: IProductSearchOptions = {}): Observable<any> {
    this.loggingService.log('FUNC | getAllProductByCategory[ProductService] category :', category);
    this.loggingService.log('FUNC | getAllProductByCategory[ProductService] options :', options);
    return this.apiService.getProductTable(VISIBILITY, category, options).pipe(
      tap((res: IAllData) => this.loggingService.log('TAP | getAllProductByCategory[ProductService] :', res)),
      tap((res: IAllData) => {
        this.loggingService.log('getAllProductByCategory options :', options);
        // Checks if the object has no keys
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getAllProductByCategory[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  // NOTE: getProductById
  //#region
  getProductById(id: number) {
    this.productDetailLoadingSignal.set(true);
    return this.apiService.getProductById(VISIBILITY, id).pipe(
      tap((res) => this.loggingService.log('TAP | getProductById[ProductService] :', res)),
      tap((res) => {
        this.productDetailSignal.set(res);
        this.productDetailLoadingSignal.set(false);
      }),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getProductById[ProductService] :', error);
        this.productDetailLoadingSignal.set(false);
        return throwError(() => error);
      })
    );
  }
  //#endregion

  // NOTE: getTireDecInc
  //#region
  getTireDecInc(options: ETireDecInc, preq: ITireDecIncRequire) {
    return this.apiService.getTireDecInc(VISIBILITY, options, preq).pipe(
      tap((res) => this.loggingService.log('TAP | getTireDecInc[ProductService] :', res)),
      catchError((error) => {
        this.loggingService.error('CATCH ERROR | getProductById[ProductService] :', error);
        return throwError(() => error);
      })
    );
  }
  //#endregion
  //!SECTION //

  //dropdown selected tire size in detail page
  getTireSelectedUpDown(size: string, brand: number, model: string) {
    return this.apiService
      .getTireSelectedUpDown(size, brand, model)
      .pipe(tap((res) => this.loggingService.log('getTireSelectedUpDown || product service', res)));
  }
  //dropdown SHOW tire size in detail page
  getTireSize(preq: ITireDecIncRequire, onChange: string) {
    this.loggingService.log('check onChange', onChange);
    return this.apiService
      .getChangeTire(preq, onChange)
      .pipe(tap((res) => this.loggingService.log('getTireSize || product service', res)));
  }

  getStorage<K extends keyof ILocalStorageModel>(key: K): ILocalStorageModel[K] | null {
    return this.storageService.get(key);
  }

  getHighlightFilter() {
    return this.apiService
      .getHighlightsFilter(VISIBILITY)
      .pipe(tap((res) => this.loggingService.log('getHighlightFilter || product service', res)));
  }
  getTypesFilter() {
    return this.apiService
      .getTypesFilter(VISIBILITY)
      .pipe(tap((res) => this.loggingService.log('getTypesFilter || product service', res)));
  }
}
